import React from "react";
import { Route, Navigate } from "react-router-dom";
import ProtectedRoute from "shared/components/routing/ProtectedRoute";
import { HomeShell } from "features/shell";
import { ROUTE_PATHS } from "app/config/routePaths";

type ProtectedRoutesProps = {
  isMobileDevice: boolean;
};

/**
 * Authenticated top-level routes that all delegate to the `HomeShell`.
 *
 * `HomeShell` continues to own its nested `<Routes>`.
 * On mobile devices these top-level paths redirect to the mobile pair
 * headset flow, exactly as before.
 */
export const protectedRoutes = ({
  isMobileDevice,
}: ProtectedRoutesProps): React.ReactElement => (
  <>
    <Route
      path={`${ROUTE_PATHS.homeBrowse}/*`}
      element={
        isMobileDevice ? (
          <Navigate to={ROUTE_PATHS.mobilePairHeadset} />
        ) : (
          <ProtectedRoute>
            <HomeShell />
          </ProtectedRoute>
        )
      }
    />
    <Route
      path={`${ROUTE_PATHS.home}/*`}
      element={
        isMobileDevice ? (
          <Navigate to={ROUTE_PATHS.mobilePairHeadset} />
        ) : (
          <ProtectedRoute>
            <HomeShell />
          </ProtectedRoute>
        )
      }
    />
    <Route
      path={`${ROUTE_PATHS.browse}/*`}
      element={
        isMobileDevice ? (
          <Navigate to={ROUTE_PATHS.mobilePairHeadset} />
        ) : (
          <ProtectedRoute>
            <HomeShell />
          </ProtectedRoute>
        )
      }
    />
    <Route
      path={`${ROUTE_PATHS.watchlist}/*`}
      element={
        isMobileDevice ? (
          <Navigate to={ROUTE_PATHS.mobilePairHeadset} />
        ) : (
          <ProtectedRoute>
            <HomeShell />
          </ProtectedRoute>
        )
      }
    />
  </>
);

export default protectedRoutes;
